<template>
  <div class="finder">
    <v-header :mine='true'></v-header>
    <div class="title" ref="title" v-if="false">{{$t('finder.find')}}</div>
    <el-main class="main">
      <div class="main-nav">
        <div class="main-nav-box">
          <ul>
            <li @click="newest">{{$t('finder.filtrateTime')}}</li>
            <li @click="distance"> {{$t('finder.filtrateDis')}}</li>
            <li>
              <el-select v-model="value" :placeholder="$t('changefindpetinfo.select')">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  >
                </el-option>
              </el-select>
            </li>
          </ul>
          <!-- <div class="main-nav-right" @click="time(timeSort)">
            <span>{{$t('finder.filtrateTime')}}</span>
            <img :src="src2">
          </div>
          <div class="main-nav-left" @click="distance(timeSort)">
            <span>{{$t('finder.filtrateDis')}}</span>
            <img :src="src1">
          </div>
          <div class="main-nav-right">
            <span>zhuangtai</span>
            <img :src="src1">
          </div> -->
        </div>
      </div>
      <div class="main-content" ref="wrapper">
        <ul>
          <scroller
            style="box-sizing:border-box"
            ref="scrollBox"
            :on-refresh="refresh"
            :on-infinite="infinite"
            refresh-layer-color="#4b8bf4"
            :refreshText="$t('finder.pullRefresh')"
            :noDataText="$t('finder.noMoreFind')"
            loading-layer-color="#ccc"
          >
            <li
              class="findList row"
              :class="{'grey-bg': index % 2 == 0}"
              v-for="(item,index) in list"
              @click="intoDetail(item.id)"
              :key="index"
            >
              <div class="ownerinfo">
                <img :src="item.pic" alt="">
                <span>{{item.nickname}}</span>
              </div>
              <div class="news_states">
                <div class="losetime">{{item.loseTime.slice(0,10)}}</div>
                <div class="readtimes"><img src="../../image/read.png" alt=""><span>{{item.readTimes}}</span></div>
                <div class="findState" v-if="item.isOpen=='1'"><span>{{$t('mysearch.finding')}}</span></div>
                <div class="findState" v-if="item.isOpen=='2'"><span>{{$t('mysearch.finded')}}</span></div>
                <div class="findState" v-if="item.isOpen=='0'"><span>{{$t('mysearch.closed')}}</span></div>
              </div>
              <div class="content">{{item.content}}</div>
              <div class="findPic">
                <div v-for="(pic,ind) in JSON.parse(item.featurePhoto)" :key='ind'>
                  <img :src="pic" :onerror="errorImg" alt>
                </div>
              </div>
              <div class="place">
                <img src="../../image/gps.png" alt="">
                {{item.lostPlace}}
              </div>

              <!-- <div class="findeList-l">
                <div class="ownerinfo">
                  <img src="../../../static/img/chonglianwang.png" alt="">
                  <span>大院</span>
                </div>
                <div class="news_states">
                  <div class="losetime">
                    <img class="time-ioc" src="../../image/time.png" alt>
                    {{item.loseTime.slice(0,10)}}
                  </div>
                  <div><img src="../../image/read.png" alt=""><span>52</span></div>
                  <div class="findState">{{$t('mysearch.finding')}}</div>
                </div>
                <div class="content">{{item.content}}</div>
                
              </div>
              <div class="findeList-r">
                <img :src="item.firstPhoto" :onerror="errorImg" alt>
              </div> -->
            </li>
            
          </scroller>
        </ul>
      </div>
    </el-main>
    <v-foot :loginsuccess="loginsuccess" :loginshowflag="loginshowflag"></v-foot>
  </div>
</template>
<script>
import footernav from "../../components/footernav";
import { nearSearch } from "../../ClientServerApi/index.js";
import header from "../../components/header";
import Qs from "qs";
export default {
  name: "finder",
  inject: ["reload"],
  data() {
    return {
      items: [],
      list: "",
      src1: require("../../image/icon-down.png"),
      srcchange1: false,
      src2: require("../../image/icon-down.png"),
      srcchange2: false,
      loginsuccess: false,
      loginshowflag: true,
      page: "",
      curpage: 1,
      timeSort: "desc",
      errorImg: 'this.src="' + require("../../assets/errorimg.png") + '"', //错误图片显示路径
      pageOver: false,
      sortType: 0,
      options:[
        {
          value:1,
          label:this.$t('mysearch.finding')
        },
        {
          value:2,
          label:this.$t('mysearch.finded')
        }
      ],
      value:1
    };
  },
  mounted() {
    let winHeight =
      document.documentElement.clientHeight || document.body.clientHeight;

    this.$refs.wrapper.style.height =
      winHeight - 120  + "px";
  },
  created() {
    if (sessionStorage.getItem("login")) {
      this.loginsuccess = true;
      this.loginshowflag = false;
    }
    this.getFindList();
  },
  watch:{
    value(newvalue, oldvalue) {
			this.$nextTick(function() {
        this.list = ''
				this.getFindList()
			})
		}
  },
  methods: {
    //定位
    // distance(timeSort) {
    //   this.list = "";
    //   this.curpage = 1;
    //   if (timeSort == "desc") {
    //     this.src1 = require("../../image/icon-up.png");
    //     this.timeSort = "asc";
    //     this.getFindList();
    //     // console.log(this.timeSort);
    //   } else if (timeSort == "asc") {
    //     this.src1 = require("../../image/icon-down.png");
    //     this.timeSort = "desc";
    //     this.getFindList();
    //     // console.log(this.timeSort);
    //   } else {
    //     // console.log(this.timeSort);
    //   }
    // },
    // time(timeSort) {
    //   this.list = "";
    //   this.curpage = 1;
    //   if (timeSort == "desc") {
    //     this.src2 = require("../../image/icon-down.png");
    //     this.timeSort = "asc";
    //     this.getFindList();
    //     // console.log(this.timeSort);
    //   } else if (timeSort == "asc") {
    //     this.src2 = require("../../image/icon-up.png");
    //     this.timeSort = "desc";
    //     this.getFindList();
    //     // console.log(this.timeSort);
    //   } else {
    //     // console.log(this.timeSort);
    //   }
    // },
    intoDetail(id) {
      // if (sessionStorage.getItem("login")) {

      // } else {
      //   this.$router.push("/login");
      // }
      this.$router.push({
        name: "petDetails",
        query: { id: id }
      });
    },
    refresh(done) {
      setTimeout(() => {
       this.reload();
        // this.list = "";
        // this.curpage = 1;
       
        // this.getFindList();
        // done();
      }, 1500);
    },
    infinite(done) {
      setTimeout(() => {
        if (this.pageOver == false) {
          this.curpage++;
          this.getFindList();
          done();
        } else {
          done(true);
        }
      }, 1500);

      // if (this.bottom >= 30) {
      //     setTimeout(() => {
      //        alert(1)
      //     }, 1500);
      //     return;
      // }
      // setTimeout(() => {
      //     // let start = this.bottom + 1;
      //     // for (let i = start; i < start + 10; i++) {
      //     //     this.items.push(i + " - keep walking, be 2 with you.");
      //     // }
      //     // this.bottom = this.bottom + 10;

      //     setTimeout(() => {
      //         alert(2)
      //     });
      // }, 1500);
    },
    getFindList() {
      let params = Qs.stringify({
        lon: sessionStorage.getItem("lat"),
        lat: sessionStorage.getItem("lng"),
        curPage: this.curpage,
        pageSize: 5,
        contentType:this.value,
        sortType:this.sortType
      });

      nearSearch(params)
        .then(res => {
          // console.log('附近协寻：',res.data.data)
          if (res.data.header.status == 1000) {
            if (this.list == "") {
              this.list = res.data.data.list;
              this.pageOver = true;
            } else {
              if (res.data.data.list.length == 5) {
                let addlist = this.list;
                this.list = addlist.concat(res.data.data.list);
              } else if (res.data.data.list.length < 5 && res.data.data.list.length > 0) {
                let addlist = this.list;
                this.list = addlist.concat(res.data.data.list);
                this.pageOver = true;
              } else if (res.data.data.list.length == 0) {
                this.pageOver = true;
              }
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //最新
    newest(){
      this.sortType = 0
      this.list =''
      this.getFindList()
    },
    //距离
    distance(){
      this.sortType = 1
      this.list =''
      this.getFindList()
    }
  },
  components: {
    "v-foot": footernav,
    "v-header": header
  }
};
</script>
<style>
.main-nav-box ul li .el-input__inner{
  border: 0;
  height: 20px;
  line-height: 20px;
}
.main-nav-box ul li .el-input__icon{
  line-height: 20px;
}
</style>
<style scoped>
html,
body {
  height: 100%;
}
.finder {
  height: 100%;
  box-sizing: border-box;
}
.title {
  text-align: center;
  color: #828282;
  font-size: 1rem;
  position: relative;
  z-index: 1000;
  background-color: #fff;
  margin: 20px 0;
}
.main {
  padding: 0 0px;
  margin-top: 1rem;
}

.main-nav-box {
  position: relative;
  z-index: 1000;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  font-size: 0.8rem;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
}
.main-nav-box ul{
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
}
.main-nav-box ul li{
  list-style: none;
  width: 33.33%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-right: 1px solid #e6e6e6;
  margin-bottom: 15px;
}
.main-nav-box ul li:last-child{
  border-right: 0;
}
.main-nav-box ul li img{
  vertical-align: middle;
}
/* .main-nav-box div {
  padding: 10px 0;
  color: #595959;
  margin-right: 20px;
}
.main-nav-box img {
  position: relative;
  top: 5px;
} */
.main-content {
  position: relative;
}
/* .main-content ul li {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  padding: 10px 0;
  padding-left: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #e6e6e6;
}
.main-content ul li img {
  width: 5rem;
  object-fit: cover;
  height: 4rem;
}
.findList {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}
.findList .content {
  overflow: hidden;
  font-size: 0.75rem;
  padding: 5px 0;
  font-weight: 800;
  white-space: nowrap;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.findList .losetime {
  font-size: 0.65rem;
  color: #afafaf;
  margin-top: 20px;
}
.findList .losetime .time-ioc {
  width: 0.65rem;
  height: 0.65rem;
  padding-right: 5px;
  vertical-align: middle;
} */
.findList{
  list-style: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin-top: 1rem;
}
.ownerinfo{
  width: 100%;
  line-height: 3rem;
  font-size: 0.9rem;
}
.ownerinfo img{
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 0.5rem;
  vertical-align: middle;
}
.news_states{
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  padding: 0 1rem 0.5rem 3.5rem;
  font-size: 0.8rem;
  color: #999999;
}
.news_states img{
  width: 1rem;
  margin-right: .3rem;
}
.losetime{
  flex: 10;
}
.readtimes{
  flex: 8;
}
.findState{
  flex: 6;
  text-align: right;
}
.findState span{
  border-bottom: 2px solid #7dc3f2;
}
.content{
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem 0 3.5rem;
  margin-bottom: 0.5rem;
  text-align: justify;
  color: #999999;
  font-size: 0.8rem;
  line-height: 1.2rem;
  max-height: 3.6rem;
  overflow:hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.findPic{
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem 0.5rem 3.5rem;
  display: inline-flex;
  justify-content: flex-start;
}
.findPic div{
  width: 32%;
  margin: 0 1%;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.findPic div img{
  height: 4rem;
}
.place{
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem 1rem 4rem;
  font-size: 0.8rem;
  color: #999999;
}
.place img{
  width: 1rem;
}
/* .findeList-l {
  flex: 16;
  overflow: hidden;
}
.findeList-r {
  flex: 8;
  text-align: center;
} */
</style>


// WEBPACK FOOTER //
// src/m_page/finder/finder.vue